module.exports = __webpack_public_path__ + "static/media/chip.0d7327cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/chip.png
// module id = 215
// module chunks = 0